import { Badge } from '@mantine/core';
import { useNotifications } from '../../useNotifications';

/**
 * Компонент бейджа для пункта меню «Уведомления».
 *
 * - Самостоятельно подписывается на контроллер уведомлений через useNotifications
 * - Отображает количество непрочитанных уведомлений
 * - Возвращает null, если непрочитанных нет
 */
export default function NotificationsMenuBadge() {
  const unreadCount = useNotifications(s => s.unreadCount);
  if (!unreadCount) return null;
  return (
    <Badge size='xs' color='red' variant='filled'>
      {String(unreadCount)}
    </Badge>
  );
}
